import React from 'react';
import MainModal from "../UI/Modal/MainModal"; // relative to MockTests; adjust if needed
import { ButtonSubmitGreen } from "../UI/Buttons/Buttons";
import { IoCheckmarkCircle } from "react-icons/io5";

/**
 * ExamReadyModal
 * A standardized confirmation modal shown after exam generation, before starting.
 *
 * Props:
 * - isOpen: boolean — whether the modal is visible
 * - onClose: () => void — close handler
 * - onStart: () => void — called when user confirms to start
 * - examLabel: string — short exam code/label used in the message (e.g., 'NCS', 'NIS', 'UTME', 'ICAN')
 * - width?: string — optional width override for MainModal (default 600px)
 * - message?: string — optional custom message body; if omitted, a default using examLabel is used
 * - title?: string — optional title; defaults to 'Exam Ready'
 */
const ExamReadyModal = ({ isOpen, onClose, onStart, examLabel, width = '600px', message, title }) => {
  const bodyText = message || `Your ${examLabel} mock exam has been generated successfully. Click Start when you're ready. Timing begins immediately.`;
  const headerText = title || 'Exam Ready';

  return (
    <MainModal isOpen={isOpen} onClose={onClose} width={width}>
      <div style={{ padding: '16px 8px', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
          <IoCheckmarkCircle size={42} color="#3E8F93" />
        </div>
        <h4 style={{ margin: '0 0 8px', color: '#3E8F93', fontWeight: 700 }}>{headerText}</h4>
        <p style={{ fontSize: '.95rem', lineHeight: '1.55rem', margin: '0 0 18px', opacity: .9 }}>
          {bodyText}
        </p>
        <ButtonSubmitGreen onClick={onStart}>Start Exam</ButtonSubmitGreen>
      </div>
    </MainModal>
  );
};

export default ExamReadyModal;
